module.exports = __webpack_public_path__ + "static/media/wolf2.3c630cd9.png";